import { Component, Input } from '@angular/core';
import { LargeFamilyForm } from '../../forms/large-family.form';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, NgIf } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';
import {
  LargeFamilyCardsCrudComponent
} from '../../../../../common/components/large-family-cards/large-family-cards-crud/large-family-cards-crud.component';

@Component({
  selector: 'app-large-family-form',
  standalone: true,
  imports: [
    CommonModule,
    NgxMaskDirective,
    ValidationErrorsComponent,
    ReactiveFormsModule,
    LargeFamilyCardsCrudComponent
  ],
  templateUrl: './large-family-form.component.html'
})
export class LargeFamilyFormComponent {
  @Input()
  public form: LargeFamilyForm | undefined;
}
